<template>
  <v-dialog :value="value" max-width="fit-content" @input="handleDialogInput">
    <v-card
      style="
        display: flex;
        flex-direction: column;
        height: 100%;
        max-height: 90vh;
      "
    >
      <v-card-title>
        <span class="headline">Histórico</span>
        <v-spacer />
      </v-card-title>

      <v-divider></v-divider>

      <v-card-text style="flex: 1; overflow-y: auto">
        <v-data-table
          :headers="headers"
          :items="items"
          :loading="loading"
          :rows-per-page-items="rowsPerPageItems"
          :pagination.sync="tablePagination"
          :total-items="totalItems"
          rows-per-page-text="Itens por página"
          no-data-text="Sem histórico para exibir."
          hide-headers
        >
          <v-progress-linear slot="progress" color="primary" indeterminate />

          <template slot="items" slot-scope="{ item, index }">
            <td class="text-no-wrap">
              <v-layout align-center justify-start>
                <v-col class="d-flex align-center justify-center" flex="none">
                  <v-icon color="grey" size="16">history</v-icon>
                </v-col>
                <v-col class="pl-2">
                  <p class="font-weight-bold">{{ item.user_name || "--" }}</p>
                  <p class="caption">{{ item.created_at | formatDateTime }}</p>
                </v-col>
              </v-layout>
            </td>

            <td>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    class="ml-2"
                    :disabled="loading"
                    v-bind="attrs"
                    v-on="on"
                    @click="viewHistory(item, index)"
                  >
                    <v-icon color="primary">mdi-file-compare</v-icon>
                  </v-btn>
                </template>
                <span>Ver alterações</span>
              </v-tooltip>
            </td>
          </template>
        </v-data-table>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer />
        <v-btn flat color="primary" @click="closeDialog">Fechar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "DialogCreditorHistory",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    items: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    totalItems: {
      type: Number,
      default: 0,
    },
    rowsPerPageItems: {
      type: Array,
      default: () => [10, 25, 50],
    },
  },
  data() {
    return {
      headers: [
        {
          text: "Usuário/Data",
          value: "created_at",
          sortable: false,
          width: "fit-content",
        },
        {
          text: "Ações",
          value: "actions",
          sortable: false,
          width: "52px",
          align: "right",
        },
      ],
      tablePagination: {
        page: 1,
        rowsPerPage: 10,
        sortBy: null,
        descending: false,
        totalItems: this.totalItems,
      },
    };
  },
  watch: {
    totalItems: {
      handler(newTotalItems) {
        this.tablePagination = {
          ...this.tablePagination,
          totalItems: newTotalItems,
        };
      },
      immediate: true,
    },
    tablePagination: {
      handler(newPagination, oldPagination) {
        if (!oldPagination) {
          return;
        }

        const isPageChanged = newPagination.page !== oldPagination.page;
        const isRowsPerPageChanged =
          newPagination.rowsPerPage !== oldPagination.rowsPerPage;

        if (!isPageChanged && !isRowsPerPageChanged) {
          return;
        }

        if (this.value) {
          this.$emit("pagination-change", {
            page: newPagination.page,
            rowsPerPage: newPagination.rowsPerPage,
          });
        }
      },
      deep: true,
    },
  },
  methods: {
    closeDialog() {
      this.$emit("input", false);
      this.tablePagination.page = 1;
      this.tablePagination.rowsPerPage = 10;
    },
    handleDialogInput(isOpen) {
      this.$emit("input", isOpen);
    },
    getConfigDetailsByIndex(index) {
      if (!Number.isInteger(index) || index < 0) {
        return {};
      }

      const targetItem = this.items[index];
      if (!targetItem) {
        return {};
      }

      return targetItem.config_details || targetItem.config_detail || {};
    },
    viewHistory(item, index) {
      let currentConfigDetails = this.getConfigDetailsByIndex(index);
      let previousConfigDetails = {};

      if (index + 1 <= this.items.length) {
        previousConfigDetails = this.getConfigDetailsByIndex(index + 1);
      }

      this.$emit("show-config-diff", {
        currentConfigDetails,
        previousConfigDetails,
        createdAt: item && item.created_at ? item.created_at : "",
        userName: item && item.user_name ? item.user_name : "",
      });
    },
  },
};
</script>
